import { svgToURL } from 'polotno/utils/svg';

const logo = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 329 15" enable-background="new 0 0 329 15" xml:space="preserve">
<g>
	<g>
		<polygon fill="#C74D2C" points="27.5,14.5 38.8,3.2 50.1,14.5 53.3,14.5 38.8,0 24.3,14.5 		"/>
		<polygon fill="#C74D2C" points="107.4,0.5 96.1,11.8 84.9,0.5 81.6,0.5 96.1,15 110.7,0.5 		"/>
		<path fill="#C74D2C" d="M20.9,12.2H6.9c-2.6,0-4.7-2.1-4.7-4.7c0-2.6,2.1-4.7,4.7-4.7h13.9l0,0l-2.3-2.3H6.9C3.1,0.5,0,3.6,0,7.5
			c0,3.9,3.1,7,6.9,7h11.7L20.9,12.2z"/>
		<path fill="#C74D2C" d="M74.7,14.5H78l-4.9-4.9c2.5,0,4.5-2.1,4.5-4.6c0-2.5-2-4.6-4.5-4.6H58.1v14h2.3V9.6h9.4L74.7,14.5z
			 M73,2.8c1.2,0,2.2,1,2.2,2.3c0,1.3-1,2.3-2.2,2.3H60.4V2.8l0,0H73z"/>
	</g>
	<g>
		<polygon fill="#404041" points="111.8,14.5 123,3.2 134.3,14.5 137.6,14.5 123,0 108.5,14.5 		"/>
		<polygon fill="#404041" points="187.6,0.5 168.7,0.5 168.7,2.8 177,2.8 177,14.5 179.3,14.5 179.3,2.8 187.6,2.8 		"/>
		<path fill="#404041" d="M159,14.5h3.2l-4.9-4.9c2.4,0,4.5-2.1,4.5-4.6c0-2.5-2-4.6-4.5-4.6h-14.9v14h2.3V9.6h9.4L159,14.5z
			 M157.3,2.8c1.2,0,2.2,1,2.2,2.3c0,1.3-1,2.3-2.2,2.3h-12.7V2.8l0,0H157.3z"/>
		<g>
			<polygon fill="#404041" points="250.1,14.5 261.4,3.2 272.7,14.5 275.9,14.5 261.4,0 246.9,14.5 			"/>
		</g>
		<g>
			<path fill="#404041" d="M297.3,14.5h3.2l-4.9-4.9c2.4,0,4.5-2.1,4.5-4.6c0-2.5-2-4.6-4.5-4.6h-14.9v14h2.3V9.6h9.4L297.3,14.5z
				 M295.6,2.8c1.2,0,2.2,1,2.2,2.3c0,1.3-1,2.3-2.2,2.3H283V2.8l0,0H295.6z"/>
		</g>
		<g>
			<path fill="#404041" d="M322.1,0.5h-13.3v14h13.3c3.8,0,6.9-3.1,6.9-7C329,3.6,325.9,0.5,322.1,0.5z M322.1,12.2h-11V2.8h11
				c2.6,0,4.7,2.1,4.7,4.7C326.7,10.1,324.6,12.2,322.1,12.2z"/>
		</g>
		<g>
			<path fill="#404041" d="M214.7,4.6c0-2.3-1.8-4.1-4.1-4.1h-15.4v14h15.4c2.3,0,4.1-1.8,4.1-4.1c0-1.2-0.5-2.2-1.3-2.9
				C214.2,6.8,214.7,5.7,214.7,4.6z M210.6,12.2h-13.1V8.6h13.1c1,0,1.8,0.8,1.8,1.8S211.6,12.2,210.6,12.2z M210.6,6.4h-13.1V2.8
				h13.1c1,0,1.8,0.8,1.8,1.8S211.6,6.4,210.6,6.4z"/>
		</g>
		<g>
			<path fill="#404041" d="M237.3,0.5h-9c-3.8,0-6.9,3.1-6.9,7c0,3.9,3.1,7,6.9,7h9c3.8,0,6.9-3.1,6.9-7
				C244.2,3.6,241.1,0.5,237.3,0.5z M237.3,12.2l-9,0c-2.6,0-4.7-2.1-4.7-4.7c0-2.6,2.1-4.7,4.7-4.7l9,0c2.6,0,4.7,2.1,4.7,4.7
				C241.9,10.1,239.8,12.2,237.3,12.2z"/>
		</g>
	</g>
</g>
</svg>
`;

const email = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 168 12" enable-background="new 0 0 168 12" xml:space="preserve">
<g enable-background="new    ">
	<path fill="#C74D2C" d="M0,0.2h2.1v9.6H0V0.2z"/>
	<path fill="#C74D2C" d="M5.6,0.2h1.9L12,6.1V0.2h2.1v9.6h-1.8L7.6,3.7v6.1H5.6V0.2z"/>
	<path fill="#C74D2C" d="M17.4,0.2h7.3v1.9h-5.2v2h4.6v1.9h-4.6v3.7h-2.1V0.2z"/>
	<path fill="#C74D2C" d="M27.1,5L27.1,5c0-2.8,2.2-5,5.1-5c3,0,5.1,2.2,5.1,4.9v0c0,2.7-2.2,5-5.1,5C29.2,9.9,27.1,7.7,27.1,5z
		 M35.1,5L35.1,5c0-1.7-1.2-3-2.9-3c-1.7,0-2.9,1.3-2.9,3v0c0,1.6,1.2,3,2.9,3C33.9,8,35.1,6.6,35.1,5z"/>
	<path fill="#C74D2C" d="M39.8,6c0-3.3,2.6-6,6-6c3.4,0,6,2.6,6,5.4c0,2.3-1.2,3.4-2.7,3.4c-1.1,0-1.8-0.4-2.1-0.8
		c-0.5,0.4-1.1,0.8-2,0.8c-1.4,0-2.5-1-2.5-2.7c0-1.9,1.5-3.4,3.1-3.4c0.9,0,1.5,0.4,1.9,0.9L47.5,3l1.6,0.3l-0.6,3.7
		c0,0.1,0,0.3,0,0.4c0,0.5,0.4,0.9,1,0.9c1,0,1.7-1,1.7-2.8c0-2.5-2.3-4.9-5.4-4.9c-3.1,0-5.4,2.5-5.4,5.5c0,3,2.3,5.4,5.5,5.4
		c1.4,0,2.3-0.3,3.4-0.9l0.3,0.4c-1.1,0.6-2.2,1-3.6,1C42.4,12,39.8,9.3,39.8,6z M47,5.5c0-0.8-0.5-1.3-1.3-1.3
		c-0.9,0-1.6,0.8-1.6,1.9c0,0.9,0.5,1.3,1.3,1.3C46.2,7.5,47,6.6,47,5.5z"/>
	<path fill="#C74D2C" d="M54.3,5L54.3,5c0-2.8,2.1-5,5-5c1.8,0,2.9,0.6,3.8,1.5L61.7,3c-0.7-0.7-1.5-1.1-2.5-1.1
		c-1.6,0-2.8,1.3-2.8,3v0c0,1.6,1.1,3,2.8,3c1.1,0,1.8-0.4,2.5-1.1l1.3,1.4c-1,1.1-2.1,1.7-3.9,1.7C56.4,9.9,54.3,7.8,54.3,5z"/>
	<path fill="#C74D2C" d="M69.1,0.1h1.9l4.1,9.7H73l-0.9-2.2h-4.1l-0.9,2.2H65L69.1,0.1z M71.4,5.8l-1.3-3.1l-1.3,3.1H71.4z"/>
	<path fill="#C74D2C" d="M77.7,0.2h4.4c1.2,0,2.2,0.3,2.8,1c0.5,0.5,0.8,1.3,0.8,2.2v0c0,1.6-0.8,2.5-2.1,3L86,9.8h-2.5l-2.1-3.1
		h-1.7v3.1h-2.1V0.2z M82,4.8c1,0,1.6-0.5,1.6-1.4v0c0-0.9-0.6-1.4-1.7-1.4h-2.1v2.8H82z"/>
	<path fill="#C74D2C" d="M87.6,0.2h2.3l2.5,6.8L95,0.2h2.3l-3.9,9.7h-1.9L87.6,0.2z"/>
	<path fill="#C74D2C" d="M101.7,0.1h1.9l4.1,9.7h-2.2l-0.9-2.2h-4.1l-0.9,2.2h-2.2L101.7,0.1z M103.9,5.8l-1.3-3.1l-1.3,3.1H103.9z"
		/>
	<path fill="#C74D2C" d="M110.3,0.2h4.4c1.2,0,2.2,0.3,2.8,1c0.5,0.5,0.8,1.3,0.8,2.2v0c0,1.6-0.8,2.5-2.1,3l2.3,3.4h-2.5L114,6.7
		h-1.7v3.1h-2.1V0.2z M114.5,4.8c1,0,1.6-0.5,1.6-1.4v0c0-0.9-0.6-1.4-1.7-1.4h-2.1v2.8H114.5z"/>
	<path fill="#C74D2C" d="M123.5,2.1h-2.9V0.2h8v1.9h-2.9v7.7h-2.1V2.1z"/>
	<path fill="#C74D2C" d="M129.5,7.6h2.2v2.2h-2.2V7.6z"/>
	<path fill="#C74D2C" d="M133.8,5L133.8,5c0-2.8,2.1-5,5-5c1.8,0,2.9,0.6,3.8,1.5L141.2,3c-0.7-0.7-1.5-1.1-2.5-1.1
		c-1.6,0-2.8,1.3-2.8,3v0c0,1.6,1.1,3,2.8,3c1.1,0,1.8-0.4,2.5-1.1l1.3,1.4c-1,1.1-2.1,1.7-3.9,1.7C135.9,9.9,133.8,7.8,133.8,5z"/>
	<path fill="#C74D2C" d="M144.7,5L144.7,5c0-2.8,2.2-5,5.1-5c3,0,5.1,2.2,5.1,4.9v0c0,2.7-2.2,5-5.1,5C146.8,9.9,144.7,7.7,144.7,5z
		 M152.7,5L152.7,5c0-1.7-1.2-3-2.9-3c-1.7,0-2.9,1.3-2.9,3v0c0,1.6,1.2,3,2.9,3C151.5,8,152.7,6.6,152.7,5z"/>
	<path fill="#C74D2C" d="M157.8,0.2h2.3l2.5,4.1l2.5-4.1h2.3v9.6h-2.1V3.5l-2.7,4.1h-0.1l-2.7-4.1v6.2h-2.1V0.2z"/>
</g>
</svg>
`;

const phone = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 106 12" enable-background="new 0 0 106 12" xml:space="preserve">
<g enable-background="new    ">
	<path fill="#C74D2C" d="M0,8.1l3.2-2.6c1.2-1,1.7-1.5,1.7-2.3c0-0.8-0.5-1.3-1.3-1.3c-0.7,0-1.3,0.4-2,1.3L0.1,2c1-1.3,1.9-2,3.6-2
		c2,0,3.3,1.2,3.3,3v0c0,1.6-0.8,2.4-2.5,3.7L2.9,8h4.2v1.8H0V8.1z"/>
	<path fill="#C74D2C" d="M11.4,2.3L9.7,2.7L9.3,0.9l2.8-0.8h1.5v9.7h-2.1V2.3z"/>
	<path fill="#C74D2C" d="M16.5,8.1l3.2-2.6c1.2-1,1.7-1.5,1.7-2.3c0-0.8-0.5-1.3-1.3-1.3c-0.7,0-1.3,0.4-2,1.3L16.6,2
		c1-1.3,1.9-2,3.6-2c2,0,3.3,1.2,3.3,3v0c0,1.6-0.8,2.4-2.5,3.7L19.5,8h4.2v1.8h-7.2V8.1z"/>
	<path fill="#C74D2C" d="M26.3,7.6h2.2v2.2h-2.2V7.6z"/>
	<path fill="#C74D2C" d="M32.4,9c-0.7-0.7-1.1-1.7-1.1-3.7v0c0-3,1.4-5.3,4.2-5.3c1.3,0,2.2,0.4,3,1.1l-1.1,1.6
		c-0.6-0.5-1.1-0.8-2-0.8c-1.2,0-1.8,1-1.9,2.2c0.5-0.3,1-0.6,2-0.6c1.9,0,3.4,1.1,3.4,3.1v0c0,2-1.6,3.3-3.7,3.3
		C33.9,10,33,9.6,32.4,9z M36.7,6.8L36.7,6.8c0-0.8-0.6-1.4-1.7-1.4c-1,0-1.7,0.6-1.7,1.4v0c0,0.8,0.6,1.4,1.7,1.4
		C36.1,8.2,36.7,7.6,36.7,6.8z"/>
	<path fill="#C74D2C" d="M45.9,2h-4.5V0.2h7v1.6L44,9.8h-2.4L45.9,2z"/>
	<path fill="#C74D2C" d="M50.3,8.6L51.6,7c0.7,0.7,1.5,1,2.3,1c1,0,1.6-0.5,1.6-1.3v0c0-0.8-0.7-1.3-1.7-1.3c-0.6,0-1.2,0.2-1.6,0.4
		l-1.2-0.8l0.3-4.8h5.9V2H53l-0.1,1.7c0.4-0.1,0.7-0.2,1.3-0.2c1.9,0,3.4,0.9,3.4,3.1v0c0,2-1.5,3.3-3.7,3.3
		C52.4,10,51.2,9.4,50.3,8.6z"/>
	<path fill="#C74D2C" d="M60.3,7.6h2.2v2.2h-2.2V7.6z"/>
	<path fill="#C74D2C" d="M64.9,5L64.9,5c0-2.8,1.7-5,4.3-5c2.6,0,4.3,2.2,4.3,5v0c0,2.8-1.7,5-4.3,5C66.6,10,64.9,7.8,64.9,5z
		 M71.3,5L71.3,5c0-1.8-0.9-3.1-2.1-3.1S67.1,3.2,67.1,5v0c0,1.8,0.8,3.1,2.1,3.1C70.5,8.1,71.3,6.8,71.3,5z"/>
	<path fill="#C74D2C" d="M76,5L76,5c0-2.8,1.7-5,4.3-5c2.6,0,4.3,2.2,4.3,5v0c0,2.8-1.7,5-4.3,5S76,7.8,76,5z M82.4,5L82.4,5
		c0-1.8-0.9-3.1-2.1-3.1c-1.3,0-2.1,1.3-2.1,3.1v0c0,1.8,0.8,3.1,2.1,3.1S82.4,6.8,82.4,5z"/>
	<path fill="#C74D2C" d="M86.8,8.3l1.5-1.4c0.7,0.7,1.4,1.2,2.3,1.2c0.8,0,1.4-0.5,1.4-1.2v0c0-0.8-0.7-1.2-1.9-1.2h-0.9l-0.3-1.4
		L91.2,2h-3.8V0.2h6.5v1.6l-2.4,2.3C92.8,4.3,94,5,94,6.8v0c0,1.8-1.3,3.2-3.5,3.2C88.8,10,87.6,9.3,86.8,8.3z"/>
	<path fill="#C74D2C" d="M96.6,5L96.6,5c0-2.8,1.7-5,4.3-5c2.6,0,4.3,2.2,4.3,5v0c0,2.8-1.7,5-4.3,5C98.3,10,96.6,7.8,96.6,5z
		 M103,5L103,5c0-1.8-0.9-3.1-2.1-3.1c-1.3,0-2.1,1.3-2.1,3.1v0c0,1.8,0.8,3.1,2.1,3.1S103,6.8,103,5z"/>
</g>
</svg>
`;

export function createStaticElements(store) {
  const scale = 1;
  store.activePage.addElement({
    type: 'svg',
    src: svgToURL(logo),
    x: store.width / 2 - (329 * scale) / 2,
    y: 47,
    width: 329 * scale,
    height: 15 * scale,
    name: 'logo',
    alwaysOnTop: true,
    selectable: false,
  });

  store.activePage.addElement({
    name: 'email',
    x: 50,
    y: 47,
    width: 168,
    height: 12,
    alwaysOnTop: true,
    selectable: false,
    type: 'svg',
    src: svgToURL(email),
  });

  store.activePage.addElement({
    type: 'svg',
    src: svgToURL(phone),
    x: store.width - 106 - 50,
    y: 47,
    width: 106,
    height: 12,
    alwaysOnTop: true,
    selectable: false,
    name: 'phone',
  });
}
